import { useState, useEffect } from "react";
import combinedServices from "../../../shared/services/user-service";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import getLocalData from "../../../shared/localStorage/getData";
import "./storelist.css";
import Header from "../../../Components/clubDashboard/Header/Header";
import CategoryComponent from "./components/CategoryComponent";
import AttributeComponent from "./components/AttributeComponent";
import ProductComponent from "./components/ProductComponent";
import InventoryComponent from "./components/InventoryComponent";
import OrderComponent from "./components/OrderComponent";
import PaypalCreds from "./components/PaypalCreds";

const StoreCard = ({ store, onStoreClick, isSelected }) => {
  let images = [];
  try {
    images = store.storeimage || "[]";
  } catch (e) {
    console.error("Failed to parse store images for store ID " + store.id, e);
  }

  const formatDistricts = (districts) => {
    if (!districts || !Array.isArray(districts)) return "";
    return districts.map((id) => `D${id}`).join(", ");
  };

  return (
    <div
      className={`store-card-wrapper ${isSelected ? "selected" : ""}`}
      onClick={() => onStoreClick(store.id)}
    >
      <div className="inner d-flex align-items-center">
        <div className="img">
          <img
            src={
              images[0] || "https://via.placeholder.com/250x150?text=No+Image"
            }
            alt={store.storename || "Store"}
            className="store-image"
          />
        </div>
        <div className="name ms-3">
          {store.storename || "Store Name"}
          <div className="pt-1">
            {store.district && (
              <span className="store-districts">
                {formatDistricts(store.district)}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const Store = () => {
  const [storeData, setStoreData] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("categoryList");
  const [storeID, setStoreID] = useState(0);
  const [searchParams] = useSearchParams();
  const [categories, setCategories] = useState([]);
  const [totalCategories, setTotalCategories] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteStatus, setdeleteStatus] = useState();

  // forattributes
  const [attributes, setattributes] = useState([]);
  const [totalattributes, setTotalattributes] = useState(0);
  const [attributepage, setattributePage] = useState(1);
  const [attributelimit, setattributeLimit] = useState(10);
  const [attributesearchQuery, setattributeSearchQuery] = useState("");
  const [attributedeleteStatus, setattributedeleteStatus] = useState();

  useEffect(() => {
    if (getLocalData("user_info", "isLogin")) {
      const loginUserData = getLocalData("user_info", "all").userData
        .login_user_detail.data.user.id;

      const fetchStores = async () => {
        setLoading(true);
        setError(null);
        try {
          const response = await combinedServices.getstorebyuserId({
            userId: loginUserData,
          });
          if (response?.data?.data) {
            setStoreData(response.data.data || []);
            
            // Check for URL parameters to set specific store and tab
            const urlStoreId = searchParams.get('storeId');
            const urlTab = searchParams.get('tab');
            
            if (urlStoreId && response.data.data.find(store => store.id == urlStoreId)) {
              setStoreID(parseInt(urlStoreId));
              setSelectedStoreId(parseInt(urlStoreId));
            } else {
              setStoreID(response.data.data[0].id);
              setSelectedStoreId(response.data.data[0].id);
            }
            
            if (urlTab) {
              setActiveTab(urlTab);
            }
          }
        } catch (err) {
          setError("Failed to fetch stores. Please try again later.");
          console.error("Error fetching Stores:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchStores();
    } else {
      setLoading(false);
    }
  }, [searchParams]);

  const handleStoreClick = (id) => {
    setSelectedStoreId(id);
    setStoreID(id);
    // Reset pagination and filters to default when switching stores
    setPage(1);
    setLimit(10);
    setSearchQuery("");
    setattributePage(1);
    setattributeLimit(10);
    setattributeSearchQuery("");
  };

  const handleTabClick = (tabName) => {
    setActiveTab(activeTab === tabName ? null : tabName); // Toggle active tab
  };

  const renderContent = () => {
    if (loading) {
      return <div className="loading-indicator">Loading stores...</div>;
    }

    if (error) {
      return <div className="error-message">{error}</div>;
    }

    if (storeData.length === 0) {
      return <div className="empty-message">No stores found.</div>;
    }

    return (
      <div className="d-flex flex-wrap productList p-0">
        {storeData.map((store) => (
          <StoreCard
            key={store.id}
            store={store}
            onStoreClick={handleStoreClick}
            isSelected={store.id === selectedStoreId}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="store-page">
      <Header />
      <div className="dbRight">
        <section className="dbMid dbInner">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 store-list-container">
                <h1 className="store-list-title">STORES</h1>
                {renderContent()}
                <ul className="d-flex flex-wrap storeTabs">
                  <li>
                    <a
                      className={activeTab === "categoryList" ? "active" : ""}
                      onClick={() => handleTabClick("categoryList")}
                    >
                      Category List
                    </a>
                  </li>
                  <li>
                    <a
                      className={activeTab === "attributeList" ? "active" : ""}
                      onClick={() => handleTabClick("attributeList")}
                    >
                      Attribute List
                    </a>
                  </li>
                  <li>
                    <a
                      className={activeTab === "productList" ? "active" : ""}
                      onClick={() => handleTabClick("productList")}
                    >
                      Product List
                    </a>
                  </li>
                  <li>
                    <a
                      className={activeTab === "inventoryList" ? "active" : ""}
                      onClick={() => handleTabClick("inventoryList")}
                    >
                      Inventory List
                    </a>
                  </li>
                  <li>
                    <a
                      className={activeTab === "orderList" ? "active" : ""}
                      onClick={() => handleTabClick("orderList")}
                    >
                      Order List
                    </a>
                  </li>
                    <li>
                    <a
                      className={activeTab === "paypalCreds" ? "active" : ""}
                      onClick={() => handleTabClick("paypalCreds")}
                    >
                      Paypal Creds
                    </a>
                  </li>
                </ul>

                <div className="storeTable mt-4">
                  {activeTab === "categoryList" && (
                    <CategoryComponent
                      storeID={storeID}
                      page={page}
                      limit={limit}
                      searchQuery={searchQuery}
                      setPage={setPage}
                      setLimit={setLimit}
                      setSearchQuery={setSearchQuery}
                      categories={categories}
                      setCategories={setCategories}
                      totalCategories={totalCategories}
                      setTotalCategories={setTotalCategories}
                      deleteStatus={deleteStatus}
                      setdeleteStatus={setdeleteStatus}
                    />
                  )}

                  {activeTab === "attributeList" && (
                    <AttributeComponent
                      storeID={storeID}
                      attributes={attributes}
                      setattributes={setattributes}
                      totalattributes={totalattributes}
                      setTotalattributes={setTotalattributes}
                      attributepage={attributepage}
                      setattributePage={setattributePage}
                      attributelimit={attributelimit}
                      setattributeLimit={setattributeLimit}
                      attributesearchQuery={attributesearchQuery}
                      setattributeSearchQuery={setattributeSearchQuery}
                      attributedeleteStatus={attributedeleteStatus}
                      setattributedeleteStatus={setattributedeleteStatus}
                    />
                  )}

                  {activeTab === "productList" && (
                    <ProductComponent
                      storeID={storeID}
                      page={page}
                      limit={limit}
                      searchQuery={searchQuery}
                      setPage={setPage}
                      setLimit={setLimit}
                      setSearchQuery={setSearchQuery}
                    />
                  )}

                  {activeTab === "inventoryList" && (
                    <InventoryComponent
                      storeID={storeID}
                      page={page}
                      limit={limit}
                      searchQuery={searchQuery}
                      setPage={setPage}
                      setLimit={setLimit}
                      setSearchQuery={setSearchQuery}
                    />
                  )}

                  {activeTab === "orderList" && (
                    <OrderComponent
                      storeID={storeID}
                      storeName={storeData.find(store => store.id === storeID)?.storename || "Store"}
                      page={page}
                      limit={limit}
                      searchQuery={searchQuery}
                      setPage={setPage}
                      setLimit={setLimit}
                      setSearchQuery={setSearchQuery}
                    />
                  )}

                  {activeTab === "paypalCreds" && (
                    <PaypalCreds key={storeID} storeID={storeID} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Store;
